import { useReactTable, getCoreRowModel, createColumnHelper } from '@tanstack/react-table';

import Table from '../../Components/Table/Table';

import { useMoviesContext } from '../../Contexts/Movies.Context';
import { Movie } from '../../Clients/reminds';
import { Remove } from '../../Icons/Remove';

const columnHelper = createColumnHelper<Movie>();

const defaultColumns = [
  columnHelper.accessor('name', {
    header: 'Name',
  }),
  columnHelper.accessor('url', {
    header: 'Place',
    cell: props => {
      if (!props.getValue()) {
        return null;
      }
      return (
        <a href={`${props.getValue()}`} target="_blank" rel="noopener noreferrer">
          IMDb
        </a>
      );
    },
  }),
  columnHelper.display({
    id: 'actions',
    header: 'Actions',
    cell: props => {
      return <DeleteButton id={props.row.original.id} />;
    },
  }),
];
export const MoviesTable = () => {
  const { data = [] } = useMoviesContext();

  const table = useReactTable({
    data,
    columns: defaultColumns,
    getCoreRowModel: getCoreRowModel(),
  });

  return <Table table={table}></Table>;
};

const DeleteButton: React.FC<{ id: number | undefined }> = ({ id }) => {
  const { deleteMovie } = useMoviesContext();

  const handleDelete = () => {
    if (id) deleteMovie(id);
  };

  return <Remove onRemove={handleDelete} />;
};
